import React, { useEffect } from 'react'
import View from './view.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export default function Logic(props) {
  let app = useDataValue({
    context: 'app',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let installAppid = useDataValue({
    context: 'tab',
    path: 'selected.install_app_id',
    viewPath: props.viewPath,
  })

  let forceInstall = useDataValue({
    context: 'flow_shortcuts',
    path: 'forceInstall',
    viewPath: props.viewPath,
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  useEffect(() => {
    if (forceInstall !== 'true' || app.id !== installAppid) return

    if (app.companies.length > 0 && app.companies[0].status === 'granted') {
      submit({ type: 'manage', app_id: app.id })
    } else {
      setFlowTo(
        normalizePath(props.viewPath, '../ConnectionAction/Install/Content')
      )
    }
  }, [])

  return <View {...props} />
}
